import { render, staticRenderFns } from "./GroupsListContainer.vue?vue&type=template&id=9122bb44&"
import script from "./GroupsListContainer.vue?vue&type=script&lang=js&"
export * from "./GroupsListContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports